import {useState, useEffect} from "react"

const list = []
export function useWebSocket(url: string) {
    const [socket, setSocket] = useState(null)
    const [messages, setMessages] = useState([])

    useEffect(() => {
        const ws = new WebSocket(url)

        ws.onerror = () => {
            list.push({message: "Websocket connection failed!"})
        }

        ws.onopen = () => {
            list.push({message: "Connected to WebSocket server!"})
        }

        ws.onmessage = event => {
            const newMessage = JSON.parse(event.data)
            setMessages(prevMessages => [...prevMessages, newMessage])
        }

        ws.onclose = () => {
            list.push({message: "Disconnected from WebSocket server!"})
        }

        setSocket(ws)

        return () => {
            ws.close()
        }
    }, [url])

    const sendMessage = message => {
        if (socket && socket.readyState === WebSocket.OPEN) {
            socket.send(JSON.stringify(message))
        }
    }

    return {messages, sendMessage, errorList: list}
}
